import WPLE_Certpanel from './certpanel.jsx';

// import React from 'react';
// import ReactDOM, { createRoot } from 'react-dom/client';

// document.addEventListener('DOMContentLoaded', () => {
//   const dash = ReactDOM.createRoot(document.getElementById('wple-annual-ux'));
//   if (dash) {
//     dash.render(
//       <React.StrictMode>
//         <WPLE_Certpanel />
//       </React.StrictMode>
//     );
//   }

//   // const dash = document.getElementById('wple-annual-ux');
//   // if (dash) {
//   //   const root = ReactDOM.createRoot(dash);
//   //   root.render(React.createElement(<WPLE_Certpanel />));
//   // }
// });

import { render } from '@wordpress/element';

/**
 * Initialize
 */

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('wple-annual-ux');
  if (container) {
    render(
      <>
        <WPLE_Certpanel />
      </>,
      container
    );
  }
});
